export enum CheckboxStyle {
    Check,
    Toggle,
}
